// extracted by mini-css-extract-plugin
export default {"container":"PatientList_container__HhORl"};